import { createFileRoute } from "@tanstack/react-router";
import SbopIntakePage from "@/components/accelerator/SbopIntakePage";

export const Route = createFileRoute("/accelerator/sbop/")({
  head: () => ({ meta: [
    { title: 'SBOP Intake | MavenWERX Accelerator' },
    { name: 'description', content: 'Small Business Opportunity Program intake for MavenWERX SBOP cohort members.' },
    { property: 'og:title', content: 'SBOP Intake | MavenWERX Accelerator' },
    { property: 'og:description', content: 'Small Business Opportunity Program intake for MavenWERX SBOP cohort members.' },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:card', content: 'summary' },
  ] }),
  component: SbopIntakePage,
});
